<button type="button" class="btn btn-icon btn-outline-primary" placement="bottom" ngbTooltip="{{'Print' | translate}}"
    id="print.id">
    <span class="tf-icons bx bx-printer"></span>
</button>